/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import {process, State} from "@progress/kendo-data-query"
import {saveAs} from "@progress/kendo-file-saver"
import {Button} from "@progress/kendo-react-buttons"
import {ExcelExport, ExcelExportColumn, KendoOoxml} from "@progress/kendo-react-excel-export"
import {
    Grid,
    GridCellProps,
    GridColumn,
    GridDataStateChangeEvent,
    GridToolbar,
    GridColumnMenuFilter,
} from "@progress/kendo-react-grid"
import {useInternationalization} from "@progress/kendo-react-intl"
import {Tooltip} from "@progress/kendo-react-tooltip"
import { useEffect, useMemo, useState} from "react"
import {StatisticsReport} from "../../../../containers/PassRate/passRateReportSlice"
import {RootState} from "../../../../rootReducer"
import {SpinnerGrid} from "../../../../shared/CommonItems"
import {useAppSelector} from "../../../../store"
import {processExportData} from "../../../../utils/common"
import { Pager, PagerProps } from "@progress/kendo-react-data-tools"
import { columnextraProps } from "../../../../shared/ActiveGridFilter"
const DateRangeReportGrid = () => {
    let _exporter: any
    const initialState: State = { skip: 0,take: 100,sort: [{field: "bookingRef", dir: "asc"}],}
    const initStatisticsState: StatisticsReport = {fail: 0,pass: 0,tests: 0,ftp: '0.00',}
    const intl = useInternationalization()
    const dateRangeReport = useAppSelector((state: RootState) => state.containers.passRateReport.prDateRangeReport)
    const dateRangeReportisLoading = useAppSelector(
        (state: RootState) => state.containers.passRateReport.prDateRangeReportLoader,
    )
    const [dataState, setDataState] = useState(initialState)
    const [initDateRangeReport, setInitDateRangeReport] = useState<any[]>(dateRangeReport || [])
    const [statistics, setStatistics] = useState<StatisticsReport>(initStatisticsState)
    const processData= useMemo(()=>process(initDateRangeReport, dataState), [initDateRangeReport,dataState])
    const exportData= useMemo(()=> processExportData(initDateRangeReport, dataState), [initDateRangeReport,dataState])
   
    useEffect(() => {
        const headers = document.querySelectorAll(".custom-header-title")
        headers.forEach((element) => {
            const titleElement = element.querySelector(".k-column-title")            
            const text = titleElement ? titleElement.textContent : ""
            if (titleElement) {
                titleElement.setAttribute("title", text || "")
            }
        })
    }, [])

    useEffect(() => {
        setDataState(initialState)
        setInitDateRangeReport(dateRangeReport)
    }, [dateRangeReport])
    useEffect(() => {
        calculateStatistics(exportData)
    }, [exportData])
    const CustomColumnCell = (props: GridCellProps) => (
        <td title={props.dataItem[`${props.field}`]}>{props.dataItem[`${props.field}`]}</td>
    )
    const CustomDateColumnCell = (text: string) => (
        <td title={text}>{text}</td>
    )
    const extraHeaderClassName = "custom-header-title"
    const  filterOperators={
                            text: [
                                {text: "grid.filterContainsOperator", operator: "contains"},
                                {text: "grid.filterNotContainsOperator", operator: "doesnotcontain"},
                                {text: "grid.filterEqOperator", operator: "eq"},
                                {text: "grid.filterNotEqOperator", operator: "neq"},
                                {text: "grid.filterStartsWithOperator", operator: "startswith"},
                                {text: "grid.filterEndsWithOperator", operator: "endswith"},
                            ],
                        }
    const columnMenu = (props: any,field: string) => {
        const prop = {...props}
        prop.column.field = field
        return (
            <GridColumnMenuFilter
                {...prop}
                hideSecondFilter={true}
                expanded={true}
                filterOperators={filterOperators}
            />
        )
    }
    const CustomPager = (props: PagerProps) => {
    return (
        <div style={{display:"flex" ,width:"100%" ,alignItems:"center"}}>
            <div style={{flex:35}}>
                <Pager
                    responsive={true}
                    style={{display:"flex" ,width:"100%" ,alignItems:"center"}}
                    skip={props.skip}
                    take={props.take}
                    total={props.total}
                    onPageChange={props.onPageChange}
                    buttonCount={4}
                    info={true}
                    previousNext={true}
                    pageSizes={[100,200,500]}
                />
            </div>
            <div style={{flex:35}}>
               {TotalStatistics()}
            </div>
            <div style={{flex:30 ,textAlign:"right"}}>
                <span>{props.skip + 1} - {props.skip + props.take} of {props.total} items</span>
            </div>
        </div>
    );
};
const TotalStatistics=()=>{
  return (  
    <div className="row">
        <div className="col-md-2 align-self-end">
            <span className="text-truncate text-md-wrap d-block" title="Total">Total</span>
        </div>   
        <div className="col-md-8" >
           <div className="row">
            <div className="col-md-3"><span className="text-truncate text-md-wrap d-block" title="Tests">Tests</span></div>
            <div className="col-md-3"><span className="text-truncate text-md-wrap d-block" title="Pass">Pass</span></div>
            <div className="col-md-3"><span className="text-truncate text-md-wrap d-block" title="Fail">Fail</span></div>
            <div className="col-md-3"><span className="text-truncate text-md-wrap d-block" title="FTP%">FTP%</span></div>
           </div>
           <div className="row">
            <div className="col-md-3"><span className="text-truncate text-md-wrap d-block" title={statistics.tests.toString()}>{statistics.tests}</span></div>
            <div className="col-md-3"><span className="text-truncate text-md-wrap d-block" title={statistics.pass.toString()}>{statistics.pass}</span></div>
            <div className="col-md-3"><span className="text-truncate text-md-wrap d-block" title={statistics.fail.toString()}>{statistics.fail}</span></div>
            <div className="col-md-3"><span className="text-truncate text-md-wrap d-block" title={`${statistics.ftp.toString()}%`}>{statistics.ftp}%</span></div>
           </div>
        </div>   
    </div>
    
    )}
    const calculateStatistics = (data: any[]) => {
        let pass = 0
        let fail = 0
       data.forEach(item=>{
            if(item.validPass==="No"){  
                return
            }
            if(item.testResult === "PASSED"){
                pass++; 
            }
            else if(item.testResult === "FAILED"){
                fail++;
            }   
         })
         const tests = pass+fail
        const ftp = tests > 0 ? ((pass / tests) * 100).toFixed(2) : "0.00"
        setStatistics({tests, pass, fail, ftp})
    }
    
    //export Excel
    const exportExcel = (data: any[]) => {
        const workbook = _exporter.workbookOptions()
        new KendoOoxml.Workbook(workbook).toDataURL().then((dataUrl: any) => {
            saveAs(dataUrl, `Monthly-${intl.formatDate(new Date(), "yyyy-MM-ddTHH-mm-ss")}`)
        })
    }
   
return (
        <div className="position-relative">
            {dateRangeReportisLoading && <SpinnerGrid />}
            <Tooltip openDelay={100} position="bottom" anchorElement="pointer">
                <ExcelExport
                    data={processExportData(initDateRangeReport, dataState)}
                    ref={exporter => (_exporter = exporter)}
                >
                    <ExcelExportColumn field="bookingRef" title="Booking Ref" />
                    <ExcelExportColumn field="preparerID" title="PreparerID" />
                    <ExcelExportColumn field="preparerDealerName" title="Preparer Dealer" />
                    <ExcelExportColumn field="registration" title="Vehicle" />
                    <ExcelExportColumn field="vehicleType" title="Vehicle Type" />
                    <ExcelExportColumn field="customerName" title="Customer Name" />
                    <ExcelExportColumn field="testDate" title="Test Date" />
                    <ExcelExportColumn field="testResult" title="Test Result" />
                    <ExcelExportColumn field="motNo" title="MOT No" />
                    <ExcelExportColumn field="expiryDate" title="Expiry Date"  />
                    <ExcelExportColumn field="failureReason" title="Failure Reason" />
                    <ExcelExportColumn field="monthYear" title="Month" />
                    <ExcelExportColumn field="regionName" title="Region" />
                    <ExcelExportColumn field="dealerName" title="Test Station" />
                    <ExcelExportColumn field="validPass" title="Valid Results" />
                    <ExcelExportColumn field="notValidPassReason" title="Not Valid Result Reason" />
                </ExcelExport>
                <Grid
                    style={{
                        height: "calc(100vh - 16.8rem)",
                    }}
                    data={processData.data}
                    {...dataState}
                    pageable={true}
                    sortable={true}
                    total={processData.total}
                    pager={CustomPager}
                    onDataStateChange={(e: GridDataStateChangeEvent) =>setDataState(e.dataState)}
                  
                >
                    <GridToolbar>
                        <Button
                            fillMode={"flat"}
                            themeColor="primary"
                            className="buttons-container-button"
                            iconClass="fa fa-file-excel"
                            disabled={processData.total === 0}
                            onClick={() => exportExcel(exportData)}
                        >
                            Export to Excel
                        </Button>
                    </GridToolbar>
                    <GridColumn  {...columnextraProps("bookingRef", dataState, extraHeaderClassName)} field="bookingRef" title="Booking Ref" cell={CustomColumnCell}/>
                    <GridColumn  {...columnextraProps("preparerID", dataState, extraHeaderClassName)} field="preparerID" title="PreparerID"  cell={CustomColumnCell}/>
                    <GridColumn  {...columnextraProps("preparerDealerName", dataState, extraHeaderClassName)} field="preparerDealerName" title="Preparer Dealer" cell={CustomColumnCell}/>
                    <GridColumn  {...columnextraProps("registration", dataState, extraHeaderClassName)} field="registration" title="Vehicle"  cell={CustomColumnCell}/>
                    <GridColumn  {...columnextraProps("vehicleType", dataState, extraHeaderClassName)} field="vehicleType" title="Vehicle Type" cell={CustomColumnCell}/>
                    <GridColumn  {...columnextraProps("customerName", dataState, extraHeaderClassName)} field="customerName" title="Customer Name" cell={CustomColumnCell}/>
                    <GridColumn  {...columnextraProps("testDate", dataState, extraHeaderClassName)} field="bookingTestDate" title="Test Date" 
                                    cell={(props: any) => CustomDateColumnCell(props.dataItem.testDate)}
                                    columnMenu={props => columnMenu(props, "testDate")}/>
                    <GridColumn  {...columnextraProps("testResult", dataState, extraHeaderClassName)} field="testResult" title="Test Result" cell={CustomColumnCell}/>
                    <GridColumn  {...columnextraProps("motNo", dataState, extraHeaderClassName)} field="motNo" title="MOT No" cell={CustomColumnCell}/>
                    <GridColumn  {...columnextraProps("expiryDate", dataState, extraHeaderClassName)} field="motExpiryDate" title="Expiry Date" cell={(props: any) => CustomDateColumnCell(props.dataItem.expiryDate)}
                                    columnMenu={props => columnMenu(props, "expiryDate")}/>
                    <GridColumn  {...columnextraProps("failureReason", dataState, extraHeaderClassName)} field="failureReason" title="Failure Reason" cell={CustomColumnCell}/>
                    <GridColumn  {...columnextraProps("monthYear", dataState, extraHeaderClassName)} field="motTestDate" title="Month" cell={(props: any) => CustomDateColumnCell(props.dataItem.monthYear)} 
                                    columnMenu={props => columnMenu(props, "monthYear")}/>
                    <GridColumn  {...columnextraProps("regionName", dataState, extraHeaderClassName)} field="regionName" title="Region"  cell={CustomColumnCell}/>
                    <GridColumn  {...columnextraProps("dealerName", dataState, extraHeaderClassName)} field="dealerName" title="Test Station" cell={CustomColumnCell}/>
                    <GridColumn  {...columnextraProps("validPass", dataState, extraHeaderClassName)} field="validPass" title="Valid Results" cell={CustomColumnCell}/>
                    <GridColumn  {...columnextraProps("notValidPassReason", dataState, extraHeaderClassName)} field="notValidPassReason" title="Not Valid Result Reason" cell={CustomColumnCell}/>
                </Grid>
            </Tooltip>
        </div>
    )
}
export default DateRangeReportGrid
